import type { IEvent } from "../../interfaces/event";
import { mapBookings } from "./bookingsMapper";
import { normalizeBooking } from "./normalizeBooking";

/**
 * Maps and returns assigned bookings for AIEmpower context.
 */
export function logAIEmpowerBookings(bookings: IEvent[]) {
  const normalized = (bookings ?? []).map(normalizeBooking);
  const mapped = mapBookings(normalized);
  return mapped;
}
